import {
    Box,
    Card,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TextField as MaterialTextField,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {Close, DoubleArrow} from "@mui/icons-material";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {LoadingButton} from "@mui/lab";
import EventGrid from "../ChangePersonGroup/EventGrid";
import {getStatusClass} from "../../Utils/gridUtils";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {ERP_BASE_URL} from "../../../API/util";
import {getChangePersonJob, updateChangePersonJobRequest} from "../../../API/changePersonJob";
import {bindActionCreators} from "redux";
import {useParams} from "react-router-dom";
import {connect} from "react-redux";
import {withStyles} from "@mui/styles";
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import {Field, Formik} from "formik";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import {
    APPROVED,
    CANCEL_PURCHASE, DECLINED,
    DUPLICATE_MEMBERSHIP,
    TRANSFER_LATER_CANCEL_NOW,
    TRANSFER_NOW
} from "../../Utils/constants";

const useStyles = (_theme) => ({
    title: {
        display: "flex !important",
        alignItems: "center !important",
    },
    card: {
        display: "flex !important",
        backgroundColor: "#fff !important",
    },
    cardMedia: {
        flex: 1,
        width: "85px !important",
        backgroundColor: "#F1F1F1 !important",
    },
    cardContent: {
        flex: 4,
        padding: "16px !important",
    },
    flexVertical: {
        display: "flex",
        alignItems: "center",
    },
    flexCenter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    inputField: {
        flex: 1,
    },
    fieldSet: {
        display: "flex",
        alignItems: "end",
    },
    flex: {
        display: "flex",
    },
    sendout: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    send: {
        background: "green",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    sent: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "dashed",
    },
    notsent: {
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    noBgDotted: {
        background: "transparent",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        border: "red",
        borderStyle: "solid",
    },
    lightBlueBgDotted: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        background: "repeating-linear-gradient(45deg, red, red 2px, #5cd7ff 2px, #5cd7ff 8px)",
        borderStyle: "solid",
        borderColor: "red",
    },
    lightBlueBgSolid: {
        background: "#5cd7ff",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#42d142",
    },
    lightBlueBg: {
        background: "#5cd7ff",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    darkBlueBgSolid: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#42d142",
    },
    darkBlueBg: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    darkBlueBgDotted: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
    },
    noBgSolid: {
        background: "transparent",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    cyanBgSolid: {
        background: "#FDDA0D",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    cyanBgSolidv2: {
        height: "19px",
        width: "19px",
        borderColor: "red",
        borderStyle: "solid",
        marginRight: "5px",
        background: "repeating-linear-gradient(45deg, red, red 2px, #FDDA0D 2px, #FDDA0D 8px)",
    },
    cyanBgSolidv3: {
        height: "19px",
        width: "19px",
        borderColor: "#42d142",
        borderStyle: "solid",
        marginRight: "5px",
        background: "#FDDA0D",
    },
    cyanBg: {
        background: "#FDDA0D",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    grayBg: {
        background: "#757373",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    purpleBg: {
        background: "purple",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    empty: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#cacaca",
    },
    completed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "green",
        background: "green",
    },
    changed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
        background: "green",
    },
    failed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
        background: "red",
    },
    attending: {
        "background": "#68a54d !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#68a54d !important",
        },
    },
    not_attending: {
        "background": "#db6669 !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#db6669 !important",
        },
    },
    unknown: {
        "background": "#7f7f7f !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#7f7f7f !important",
        },
    },
    tentative: {
        "background": "#f9fd01 !important",
        "color": "#000 !important",
        "&:hover": {
            background: "#f9fd01 !important",
        },
    },
    appeared: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    nothing: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    happened: {
        background: "green",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    notHappened: {
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    answer: {
        "background": "#1976d2",
        "color": "#fff",
        "&:hover": {
            color: "#000",
        },
    },
    accordionSummary: {
        "& > div": {
            flexDirection: "column",
        },
    },
    historyCount: {
        background: "red",
        borderRadius: "50%",
        color: "#fff",
        fontSize: "12px",
        marginLeft: "5px",
        width: "25px",
        height: "25px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    panel: {
        backgroundColor: "#fff",
        color: "rgba(0, 0, 0, 0.87)",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: "4px",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        position: "relative",
        overflowAnchor: "none",
        padding: "15px",
    },
    checkbox: {
        width: "15px",
        height: "15px",
        cursor: "pointer",
    },
    personTable: {
        "& > tbody > tr > td": {
            padding: "5px",
            minWidth: "160px",
        },
    },
});

const ReviewTransferMembershipRequest = (props) => {
    const {
        changeJob,
        open,
        handleClose,
        classes
    } = props;
    const [person, setPerson] = useState(null);
    const [personJob, setPersonJob] = useState(null);
    const [newPerson, setNewPerson] = useState(null);
    const [meetingsCount, setMeetingsCount] = useState(null);
    const [eventOverview, setEventOverview] = useState(null);
    const [newProduct, setNewProduct] = useState(null);
    const [purchaseStart, setPurchaseStart] = useState(new Date());
    const [newProductUpcomingEvents, setNewProductUpcomingEvents] = useState([]);
    const [purchaseStop, setPurchaseStop] = useState(null);
    const [payload, setPayload] = useState(null);
    const formRef = useRef(null);

    useEffect(() => {
        if (changeJob?.hasOwnProperty('person_job_change_id') && changeJob?.hasOwnProperty('change_job_type')) {
            setPerson(null);
            setPersonJob(null);
            setNewPerson(null);
            setMeetingsCount(null);
            setNewProduct(null);
            setPurchaseStart(null);
            setPurchaseStop(null);
            setNewProductUpcomingEvents(null);
            setEventOverview(null);
            setPayload(null);

            getChangePersonJob(changeJob.person_job_change_id, changeJob.change_job_type).then((result) => {
                if (result.data) {
                    const payLoad = JSON.parse(result.data.personChangeJob.payload);

                    if (result.data.personChangeJob.change_job_type === TRANSFER_NOW
                        || result.data.personChangeJob.change_job_type === DUPLICATE_MEMBERSHIP) {
                        let newPersonData = {
                            person_id: result.data.personChangeJob.new_person_id,
                            job_title: result.data.personChangeJob.new_person_job_title,
                            job_email: result.data.personChangeJob.new_job_email,
                            job_phone: result.data.personChangeJob.new_job_phone,
                            company_name: result.data.personChangeJob.new_person_company_name,
                            person_country: result.data.personChangeJob.new_person_country,
                            person_firstname: result.data.personChangeJob.new_person_firstname,
                            person_lastname: result.data.personChangeJob.new_person_lastname,
                            person_mobile_number: result.data.personChangeJob.new_person_mobile_number,
                            person_region: result.data.personChangeJob.new_person_region,
                            person_linkedin_member_id: result.data.personChangeJob.new_person_person_linkedin_member_id,
                            person_linkedin_url: result.data.personChangeJob.new_person_person_linkedin_url,
                        }

                        setPerson(result.data.personChangeJob.person);
                        setPersonJob(result.data.personChangeJob.purchase.job);
                        setNewPerson(newPersonData);
                        setMeetingsCount(payLoad.new_events.length);
                        setNewProduct(payLoad.product);
                        setPurchaseStart(payLoad.purchase_start);
                        setPurchaseStop(payLoad.purchase_stop);
                        setNewProductUpcomingEvents(payLoad.new_events);
                        setEventOverview(result.data.event_overview);
                    } else if (result.data?.personChangeJob.change_job_type === TRANSFER_LATER_CANCEL_NOW ||
                        result.data?.personChangeJob.change_job_type === CANCEL_PURCHASE) {
                        setPerson(result.data?.personChangeJob.person);
                        setPersonJob(result.data.personChangeJob.purchase?.job);
                        setPayload(payLoad);
                    }
                }
            }).catch((_err) => {
            })
        }
    }, [changeJob]);

    const handleProcessClick = (status) => {
        let data = {
            status: status.toLowerCase(),
            type: changeJob.change_job_type,
            reviewer_comments: formRef.current.values.reviewer_comments
        }
        Swal.fire({
            title: `Are you sure want to ${status === APPROVED ? "approve" : "decline"} this request?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                updateChangePersonJobRequest(changeJob.person_job_change_id, data).then((res) => {
                    if (res.message) {
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 2000
                        });
                        handleClose(true);
                    }
                }).catch((_err) => {
                    toast.error(_err, {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 2000
                    });
                });
            }
        })
    }

    return (
        <div>
            <Dialog open={open} onClose={(_event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose(false);
                }
            }} scroll="paper" fullWidth
                    maxWidth={changeJob.change_job_type === TRANSFER_NOW || changeJob.change_job_type === DUPLICATE_MEMBERSHIP ? "lg" : "md"}>
                <DialogTitle>Review Transfer Membership Request</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <Close/>
                </IconButton>
                <DialogContent>
                    <Formik
                        innerRef={formRef}
                        initialValues={{
                            reviewer_comments: "",
                        }}
                    >
                        <form>
                            {(changeJob.change_job_type === TRANSFER_NOW || changeJob.change_job_type === DUPLICATE_MEMBERSHIP) &&
                                <Grid container>
                                    <Grid container spacing={2} sx={{padding: "10px"}}>
                                        <Grid item xs={5}>
                                            <Card className='rounded-box'>
                                                <Typography variant="span" component="span"
                                                            sx={{paddingBottom: "10px", fontWeight: 'bold'}}>
                                                    Existing Member
                                                </Typography>
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Person Name:</TableCell>
                                                                <TableCell>
                                                                    <a target="_blank"
                                                                       href={`${ERP_BASE_URL}/#/contacts/persons/${person?.person_id}`}>
                                                                        {person?.person_firstname} {person?.person_lastname}
                                                                    </a>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Mobile Number:</TableCell>
                                                                <TableCell>{person?.person_mobile_number}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Company Name:</TableCell>
                                                                <TableCell>{personJob?.division.company.company_name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Title:</TableCell>
                                                                <TableCell>{personJob?.job_title}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Email:</TableCell>
                                                                <TableCell>{personJob?.job_email}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Phone:</TableCell>
                                                                <TableCell>{personJob?.job_phone}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>LinkedIn Profile:</TableCell>
                                                                <TableCell><a href={person?.person_linkedin_url}
                                                                              target="_blank">{person?.person_linkedin_member_id}</a></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Region:</TableCell>
                                                                <TableCell>{person?.person_region}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Country:</TableCell>
                                                                <TableCell>{person?.person_country}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <div className={classes?.flex} style={{marginTop: '20px'}}>
                                                    {
                                                        eventOverview?.map((item, index) => {
                                                            const color = getStatusClass(item);
                                                            return (
                                                                <Tooltip
                                                                    key={index}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div>{item.event_name}</div>
                                                                            <div>Date: {moment(item.event_start).format("DD/MM/YYYY HH:mm")}</div>
                                                                            <div>
                                                                                {item.event_has_happened ? (
                                                                                    <>
                                                                                        {item.rating_nps ? <div>NPS
                                                                                                                Rating: {item.rating_nps}</div> : <></>}{" "}
                                                                                        {item.rating_overall ?
                                                                                            <div>Overall
                                                                                                 Rating: {item.rating_overall}</div> : <></>}{" "}
                                                                                    </>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <div className={classes[color]}></div>
                                                                </Tooltip>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={2} sx={{margin: 'auto', textAlign: 'center'}}>
                                            <DoubleArrow sx={{fontSize: '50px'}}/>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Card className='rounded-box'>
                                                <Typography variant="span" component="span"
                                                            sx={{paddingBottom: "10px", fontWeight: 'bold'}}>
                                                    New Member
                                                </Typography>

                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Person Name:</TableCell>
                                                                <TableCell>
                                                                    <a target="_blank"
                                                                       href={`${ERP_BASE_URL}/#/contacts/persons/${newPerson?.person_id}`}>
                                                                        {newPerson?.person_firstname} {newPerson?.person_lastname}
                                                                    </a></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Mobile Number:</TableCell>
                                                                <TableCell>{newPerson?.person_mobile_number}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Company Name:</TableCell>
                                                                <TableCell>{newPerson?.company_name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Title:</TableCell>
                                                                <TableCell>{newPerson?.job_title}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Email:</TableCell>
                                                                <TableCell>{newPerson?.job_email}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Phone:</TableCell>
                                                                <TableCell>{newPerson?.job_phone}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>LinkedIn Profile:</TableCell>
                                                                <TableCell><a href={newPerson?.person_linkedin_url}
                                                                              target="_blank">{newPerson?.person_linkedin_member_id}</a></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Region:</TableCell>
                                                                <TableCell>{newPerson?.person_region}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Country:</TableCell>
                                                                <TableCell>{newPerson?.person_country}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{padding: "10px"}}>
                                        <Grid item xs={5}>
                                            <Card className='rounded-box' sx={{backgroundColor: "#F8F8F8"}}>
                                                <Box>
                                                    <Field
                                                        component='textarea'
                                                        fullWidth
                                                        rows='5'
                                                        size='large'
                                                        name='reviewer_comments'
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            fontSize: "16px",
                                                            borderColor: "#c4c4c4",
                                                            borderRadius: "5px",
                                                        }}
                                                        placeholder='Comments'
                                                    />
                                                </Box>
                                                <Box display='flex' justifyContent='center'>
                                                    <LoadingButton variant='contained'
                                                                   color='primary'
                                                                   onClick={() => handleProcessClick(APPROVED)}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Approve
                                                    </LoadingButton>
                                                    <LoadingButton variant='contained'
                                                                   color='error'
                                                                   onClick={() => handleProcessClick(DECLINED)}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Decline
                                                    </LoadingButton>
                                                    <LoadingButton variant='contained'
                                                                   color='secondary'
                                                                   onClick={handleClose}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Cancel
                                                    </LoadingButton>
                                                </Box>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={2} sx={{margin: 'auto'}}>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Card className='rounded-box'>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <TextField type="text"
                                                                       label='Product'
                                                                       variant="outlined"
                                                                       margin='normal'
                                                                       size='small'
                                                                       inputProps={{readOnly: true}}
                                                                       fullWidth
                                                                       InputLabelProps={{shrink: true}}
                                                                       value={newProduct?.product_name}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                type='number'
                                                                label='Meetings Count'
                                                                variant="outlined"
                                                                margin='normal'
                                                                size='small'
                                                                InputLabelProps={{shrink: true}}
                                                                inputProps={{readOnly: true}}
                                                                fullWidth
                                                                value={meetingsCount}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DatePicker
                                                                    name='purchase_start'
                                                                    label='Purchase Start*'
                                                                    inputFormat='dd/MM/yyyy'
                                                                    value={purchaseStart}
                                                                    readOnly={true}
                                                                    disabled={true}
                                                                    inputProps={{readOnly: true}}
                                                                    renderInput={(startProps) => (
                                                                        <MaterialTextField
                                                                            {...startProps}
                                                                            sx={{
                                                                                width: "100%",
                                                                                marginTop: "10px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>

                                                        </Grid>

                                                        <Grid item xs={6}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DatePicker
                                                                    name='purchase_stop'
                                                                    label='Purchase Stop*'
                                                                    inputFormat='dd/MM/yyyy'
                                                                    value={purchaseStop} // Set the initial value
                                                                    onChange={() => {
                                                                    }}
                                                                    disabled={true}
                                                                    inputProps={{readOnly: true}}
                                                                    renderInput={(startProps) => (
                                                                        <MaterialTextField
                                                                            {...startProps}
                                                                            sx={{
                                                                                width: "100%",
                                                                                marginTop: "10px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                {
                                                    newProductUpcomingEvents?.length > 0 &&
                                                    <Grid item xs={12}>
                                                        <Box style={{padding: "12px"}}>
                                                            <Typography variant='h6' component='h6'>
                                                                Upcoming events ({newProduct?.product_name})
                                                            </Typography>
                                                            <Card className='rounded-box'>
                                                                <EventGrid events={newProductUpcomingEvents}/>
                                                            </Card>
                                                        </Box>
                                                    </Grid>
                                                }
                                            </Card>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                            {(changeJob.change_job_type == TRANSFER_LATER_CANCEL_NOW || changeJob.change_job_type == CANCEL_PURCHASE) &&
                                <Grid container>

                                    <Grid container sx={{padding: "10px"}}>
                                        <Grid item xs={12}>
                                            <Card className='rounded-box'>
                                                <Typography variant="span" component="span"
                                                            sx={{paddingBottom: "10px", fontWeight: 'bold'}}>
                                                    Transfer Type : {changeJob.change_job_type}
                                                </Typography>
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Person Name:</TableCell>
                                                                <TableCell>
                                                                    <a target="_blank"
                                                                       href={`${ERP_BASE_URL}/#/contacts/persons/${person?.person_id}`}>
                                                                        {person?.person_firstname} {person?.person_lastname}
                                                                    </a>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Purchase:</TableCell>
                                                                <TableCell>
                                                                    <a target="_blank"
                                                                       href={`${ERP_BASE_URL}/#/sales/purchases/${changeJob.purchase_id}`}>
                                                                        {changeJob.purchase_id}
                                                                    </a>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Mobile Number:</TableCell>
                                                                <TableCell>{person?.person_mobile_number}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Company Name:</TableCell>
                                                                <TableCell>{personJob?.division.company.company_name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Title:</TableCell>
                                                                <TableCell>{personJob?.job_title}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Email:</TableCell>
                                                                <TableCell>{personJob?.job_email}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Job Phone:</TableCell>
                                                                <TableCell>{personJob?.job_phone}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>LinkedIn Profile:</TableCell>
                                                                <TableCell><a href={person?.person_linkedin_url}
                                                                              target="_blank">{person?.person_linkedin_member_id}</a></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Region:</TableCell>
                                                                <TableCell>{person?.person_region}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Person Country:</TableCell>
                                                                <TableCell>{person?.person_country}</TableCell>
                                                            </TableRow>
                                                            {(changeJob.change_job_type == TRANSFER_LATER_CANCEL_NOW) &&
                                                                <TableRow>
                                                                    <TableCell>Tentative Transfer Date:</TableCell>
                                                                    <TableCell>{moment(payload?.tentative_transfer_date).format("DD/MM/YYYY")}</TableCell>
                                                                </TableRow>
                                                            }
                                                            {(changeJob.change_job_type == CANCEL_PURCHASE) &&
                                                                <TableRow>
                                                                    <TableCell>Cancel From:</TableCell>
                                                                    <TableCell>{moment(payload?.canceled_from).format("DD/MM/YYYY")}</TableCell>
                                                                </TableRow>
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <div className={classes?.flex} style={{marginTop: '20px'}}>
                                                    {
                                                        eventOverview?.map((item, index) => {
                                                            const color = getStatusClass(item);
                                                            return (
                                                                <Tooltip
                                                                    key={index}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div>{item.event_name}</div>
                                                                            <div>Date: {moment(item.event_start).format("DD/MM/YYYY HH:mm")}</div>
                                                                            <div>
                                                                                {item.event_has_happened ? (
                                                                                    <>
                                                                                        {item.rating_nps ? <div>NPS
                                                                                                                Rating: {item.rating_nps}</div> : <></>}{" "}
                                                                                        {item.rating_overall ?
                                                                                            <div>Overall
                                                                                                 Rating: {item.rating_overall}</div> : <></>}{" "}
                                                                                    </>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <div className={classes[color]}></div>
                                                                </Tooltip>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </Card>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Card className='rounded-box' sx={{backgroundColor: "#F8F8F8"}}>
                                                <Box>
                                                    <Field
                                                        component='textarea'
                                                        fullWidth
                                                        rows='5'
                                                        size='large'
                                                        name='reviewer_comments'
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            fontSize: "16px",
                                                            borderColor: "#c4c4c4",
                                                            borderRadius: "5px",
                                                        }}
                                                        placeholder='Comments'
                                                    />
                                                </Box>
                                                <Box display='flex' justifyContent='center'>
                                                    <LoadingButton variant='contained'
                                                                   color='primary'
                                                                   onClick={() => handleProcessClick(APPROVED)}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Approve
                                                    </LoadingButton>
                                                    <LoadingButton variant='contained'
                                                                   color='error'
                                                                   onClick={() => handleProcessClick(DECLINED)}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Decline
                                                    </LoadingButton>
                                                    <LoadingButton variant='contained'
                                                                   color='secondary'
                                                                   onClick={handleClose}
                                                                   style={{marginTop: "10px", marginRight: "5px"}}
                                                    >
                                                        Cancel
                                                    </LoadingButton>
                                                </Box>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                        </form>
                    </Formik>
                </DialogContent>

            </Dialog>
        </div>
    );
}

const mapStateToProps = (_state) => ({});


const mapDispatchToProps = (dispatch) => bindActionCreators(
    {},
    dispatch);

function WithNavigate(props) {
    let params = useParams();
    return <ReviewTransferMembershipRequest {...props} params={params}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));